import { is } from '@common/is/is'

import globals from './globals'

/** Az adott böngészőben engedjük-e futtatni az appot? */
export default async function checkRestricted (): Promise<boolean> {
  if (is.empty(globals.restrictions)) {
    return false
  }

  const { default: RestrictionHandler } = await import(
    /* webpackChunkName: "RestrictionHandler" */
    '@common/RestrictionHandler/RestrictionHandler'
  )

  const restrictionHandler = new RestrictionHandler()

  const isRestricted = restrictionHandler.isRestricted(globals.restrictions)

  if (isRestricted) {
    const { default: template } = await import(
      /* webpackChunkName: "restricted" */
      './templates/restricted.pug'
    )

    // eslint-disable-next-line @typescript-eslint/naming-convention
    const { innerHTML } = document.body

    document.body.innerHTML = innerHTML + template({})

    return true
  }

  return false
}
